var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vcl-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns}}),_vm._v(" "),(!_vm.hideCircle)?[_c('br'),_c('br'),_vm._v(" "),_c('vue-content-loading',_vm._b({attrs:{"width":100,"height":100}},'vue-content-loading',_vm.$attrs,false),[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":_vm.radius}})])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }